(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-brand-closing"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ns-brand-closing')){
  customElements.define('ns-brand-closing',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.stage=this.querySelector('[data-ns-close-stage]');this.photos=[...this.querySelectorAll('[data-ns-close-photo]')];
      this.index=0;this.visible=false;this.interval=Math.max(3000,Number(this.dataset.interval||4)*1000);this.mobile=matchMedia('(max-width:749px)');this.motion=matchMedia('(prefers-reduced-motion:reduce)');
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.5;this.schedule();},{threshold:[0,.5]});this.observer.observe(this.stage);
      this.mobile.addEventListener('change',()=>{this.paint();this.schedule();},options);this.motion.addEventListener('change',()=>this.schedule(),options);document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.addEventListener('shopify:block:select',e=>{const p=e.target.closest('[data-ns-close-photo]');if(p)this.show(this.photos.indexOf(p));},options);this.paint();
    }
    show(index){if(!this.photos.length)return;this.index=(index+this.photos.length)%this.photos.length;this.paint();this.schedule();}
    paint(){this.photos.forEach((p,i)=>{const hidden=this.mobile.matches&&i!==this.index;p.toggleAttribute('data-active',i===this.index);p.toggleAttribute('aria-hidden',hidden);if(hidden)p.setAttribute('aria-hidden','true');p.inert=hidden;});}
    stop(){clearTimeout(this.timer);this.timer=null;}
    schedule(){this.stop();if(!this.isConnected||!this.mobile.matches||this.motion.matches||!this.visible||document.hidden||this.photos.length<2)return;this.timer=setTimeout(()=>this.show(this.index+1),this.interval);}
    disconnectedCallback(){this.stop();this.observer?.disconnect();this.abort?.abort();this.abort=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-footer-premium"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ns-footer-premium'))customElements.define('ns-footer-premium',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.media=matchMedia('(max-width:749px)');
    const paint=()=>this.querySelectorAll('[data-ns-footer-disclosure]').forEach(el=>{if(!this.media.matches||!el.contains(document.activeElement))el.open=!this.media.matches;});
    paint();this.media.addEventListener('change',paint,options);this.querySelector('.ns-footer').setAttribute('data-enhanced','');
    this.querySelectorAll('[data-ns-footer-locale]').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit(),options));
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ns-header')) {
  customElements.define('ns-header', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      if (this.classList.contains('ns-h-home')) {
        const updateScroll = () => {
          this.scrollFrame = null;
          const scrolled = window.scrollY > 16;
          this.classList.toggle('ns-h-scrolled', scrolled);
          const announcement = this.querySelector('.ns-h-announcement');
          if (announcement) {
            const hideAnnouncement = scrolled && this.dataset.nsArea !== 'packs';
            announcement.inert = hideAnnouncement;
            announcement.setAttribute('aria-hidden', String(hideAnnouncement));
          }
        };
        window.addEventListener('scroll', () => {
          if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(updateScroll);
        }, { passive: true, signal: this.abort.signal });
        updateScroll();
      }
      this.querySelectorAll('[data-ns-open]').forEach(button => button.addEventListener('click', () => this.openDialog(button.dataset.nsOpen, button), options));
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (link) link.closest('dialog')?.close();
      }, options);
      this.querySelectorAll('[data-ns-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close(), options));
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            dialog.close();
          }
        }, options);
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          this.querySelectorAll('[data-ns-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
          document.body.classList.remove('ns-h-modal-open');
          clearTimeout(this.searchTimer);
          this.searchAbort?.abort();
        }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, options);
      });
      const input = this.querySelector('[data-ns-search-input]');
      input?.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchAbort?.abort();
        const term = input.value.trim();
        this.querySelector('[data-ns-search-status]').textContent = '';
        if (term.length < 2) {
          this.querySelector('[data-ns-search-defaults]').hidden = false;
          this.querySelector('[data-ns-search-results]').hidden = true;
          return;
        }
        this.searchTimer = setTimeout(() => this.search(term), 220);
      }, options);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(this)) this.disconnectedCallback(); }, options);
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.abort?.abort();
      this.searchAbort?.abort();
      clearTimeout(this.searchTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      document.body.classList.remove('ns-h-modal-open');
    }
    openDialog(name, trigger) {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      const dialog = this.querySelector(`[data-ns-dialog="${name}"]`);
      if (!dialog) return;
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ns-h-modal-open');
      if (name === 'menu') dialog.querySelector('[data-ns-close]').focus({ preventScroll: true });
      if (name === 'search') dialog.querySelector('input[type="search"]').focus({ preventScroll: true });
    }
    async search(term) {
      this.searchAbort = new AbortController();
      const controller = this.searchAbort;
      const status = this.querySelector('[data-ns-search-status]');
      const results = this.querySelector('[data-ns-search-results]');
      const defaults = this.querySelector('[data-ns-search-defaults]');
      const url = new URL(this.dataset.searchUrl, window.location.origin);
      url.search = new URLSearchParams({ q: term, 'resources[type]': 'product', 'resources[limit]': '6', section_id: 'ns-header-search' }).toString();
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (controller.signal.aborted || term !== this.querySelector('[data-ns-search-input]').value.trim()) return;
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ns-results]');
        if (!content) throw new Error('Search unavailable');
        results.replaceChildren(...content.childNodes);
        defaults.hidden = true;
        results.hidden = false;
        status.textContent = status.dataset.ready;
      } catch (error) {
        if (error.name === 'AbortError') return;
        defaults.hidden = false;
        results.hidden = true;
        status.textContent = status.dataset.error;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-rest-detail-opinion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ns-rest-story')) {
  customElements.define('ns-rest-story', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = Array.from(this.querySelectorAll('[data-ns-rest-story]'));
      if (this.slides.length < 2) return;
      this.current = 0;
      this.interval = Math.max(3000, Number(this.dataset.interval || 4) * 1000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.focusWithin = false;
      this.allowFocusedPlay = false;
      const stage = this.querySelector('[data-ns-story-stage]');
      this.stage = stage;
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY };
      }, options);
      stage.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const x = event.clientX - this.touchStart.x;
        const y = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y)) {
          this.skipClickUntil = performance.now() + 500;
          this.select(this.current + (x < 0 ? 1 : -1), true);
        }
      }, options);
      stage.addEventListener('pointercancel', () => this.touchStart = null, options);
      this.addEventListener('focusin', () => {
        this.focusWithin = true;
        this.allowFocusedPlay = false;
        this.syncTimer();
      }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        this.focusWithin = this.contains(document.activeElement);
        if (!this.focusWithin) this.allowFocusedPlay = false;
        this.syncTimer();
      }), options);
      stage.addEventListener('click', () => {
        if (performance.now() < (this.skipClickUntil || 0)) return;
        this.togglePause();
      }, options);
      stage.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.togglePause();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncTimer(), options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updateToggle();
        this.syncTimer();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
        this.syncTimer();
      }, { threshold: [0, .5] });
      this.observer.observe(stage);
      this.select(0, false);
      this.updateToggle();
    }
    select(index, manual) {
      this.current = (index + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      this.slides.forEach((slide, i) => {
        slide.toggleAttribute('data-active', i === this.current);
        slide.setAttribute('aria-hidden', String(i !== this.current));
      });
      if (manual) this.updateToggle();
      this.syncTimer();
    }
    togglePause() {
      this.paused = !this.paused;
      this.allowFocusedPlay = !this.paused;
      this.updateToggle();
      this.syncTimer();
    }
    updateToggle() {
      this.stage.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.stage.setAttribute('aria-pressed', String(this.paused));
    }
    syncTimer() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.visible || document.hidden || this.paused || (this.focusWithin && !this.allowFocusedPlay)) return;
      this.timer = setTimeout(() => {
        this.timer = null;
        this.select(this.current + 1, false);
      }, this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-video-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ns-video-carousel')) {
  customElements.define('ns-video-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController(); const options = {signal:this.abort.signal};
      this.rail=this.querySelector('[data-ns-video-rail]');this.bar=this.querySelector('[data-ns-video-scrollbar]');this.thumb=this.querySelector('[data-ns-video-thumb]');
      this.cards=[...this.querySelectorAll('[data-ns-video-card]')];this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.visibleVideos=new Set();
      this.dialog=this.querySelector('[data-ns-video-dialog]');this.player=this.querySelector('[data-ns-video-player]');this.index=0;
      this.rail.addEventListener('scroll',()=>this.updateScrollbar(),options);
      this.rail.addEventListener('keydown',e=>{if(e.target===this.rail)this.navigate(e);},options);this.bar.addEventListener('keydown',e=>this.navigate(e),options);
      this.rail.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;this.drag={x:e.clientX,left:this.rail.scrollLeft,moved:false};},options);
      this.rail.addEventListener('pointermove',e=>{if(!this.drag)return;const dx=e.clientX-this.drag.x;if(Math.abs(dx)>6){this.drag.moved=true;this.rail.setAttribute('data-dragging','');this.rail.scrollLeft=this.drag.left-dx;}},options);
      const release=()=>{if(this.drag?.moved)this.suppressClickUntil=Date.now()+350;this.drag=null;this.rail.removeAttribute('data-dragging');};
      window.addEventListener('pointerup',release,options);this.rail.addEventListener('pointercancel',release,options);
      this.bar.addEventListener('pointerdown',e=>{if(e.button!==0)return;e.preventDefault();this.bar.focus({preventScroll:true});const r=this.thumb.getBoundingClientRect();this.barOffset=e.target===this.thumb?e.clientX-r.left:r.width/2;this.barDragging=true;this.rail.setAttribute('data-dragging','');this.bar.setPointerCapture(e.pointerId);this.scrub(e.clientX);},options);
      this.bar.addEventListener('pointermove',e=>{if(this.barDragging)this.scrub(e.clientX);},options);
      const barRelease=()=>{this.barDragging=false;this.rail.removeAttribute('data-dragging');};['pointerup','pointercancel','lostpointercapture'].forEach(n=>this.bar.addEventListener(n,barRelease,options));
      this.cards.forEach((card,i)=>{card.querySelector('[data-ns-video-toggle]').addEventListener('click',()=>{if(Date.now()<(this.suppressClickUntil||0))return;this.opener=card.querySelector('button');this.openVideo(i);},options);});
      this.dialog.querySelector('[data-ns-player-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.querySelector('[data-ns-player-prev]').addEventListener('click',()=>this.openVideo(this.index-1),options);
      this.dialog.querySelector('[data-ns-player-next]').addEventListener('click',()=>this.openVideo(this.index+1),options);
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},options);
      this.dialog.addEventListener('close',()=>{this.player.pause();this.player.removeAttribute('src');this.player.load();document.body.classList.remove('ns-video-modal-open');this.syncPreviews();this.opener?.focus({preventScroll:true});},options);
      this.player.addEventListener('error',()=>{const e=this.querySelector('[data-ns-player-error]');e.textContent=this.dataset.error;e.hidden=false;},options);
      this.videoObserver=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting&&e.intersectionRatio>=.35)this.visibleVideos.add(e.target);else{this.visibleVideos.delete(e.target);e.target.pause();}});this.syncPreviews();},{threshold:[0,.35]});
      this.posterObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)return;const video=entry.target;if(video.dataset.nsPoster)video.poster=video.dataset.nsPoster;this.posterObserver.unobserve(video);});},{rootMargin:'300px 0px'});
      this.cards.forEach(c=>{const v=c.querySelector('video');if(v){this.posterObserver.observe(v);this.videoObserver.observe(v);}});
      document.addEventListener('visibilitychange',()=>{this.syncPreviews();if(document.hidden)this.player.pause();},options);this.motion.addEventListener('change',()=>this.syncPreviews(),options);
      this.resizeObserver=new ResizeObserver(()=>this.updateScrollbar());this.resizeObserver.observe(this.rail);this.updateScrollbar();
      this.addEventListener('shopify:block:select',e=>{const c=e.target.closest('[data-ns-video-card]');if(c)this.rail.scrollTo({left:c.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'});},options);
    }
    source(card,full=false) {if(!full&&card.dataset.previewSrc)return {url:card.dataset.previewSrc};let sources=[];try{sources=JSON.parse(card.dataset.sources||'[]');}catch{}const mp4=sources.filter(s=>s.format==='mp4'||s.mime_type==='video/mp4').sort((a,b)=>a.width-b.width);if(full)return mp4.at(-1);const width=card.clientWidth*Math.min(devicePixelRatio||1,2);return mp4.find(s=>s.width>=width)||mp4.at(-1);}
    openVideo(index) {if(index<0||index>=this.cards.length)return;const card=this.cards[index],src=this.source(card,true);if(!src)return;this.index=index;this.player.pause();this.player.src=src.url;this.player.poster=card.querySelector('video')?.poster||card.querySelector('video')?.dataset.nsPoster||'';this.player.muted=false;this.querySelector('[data-ns-player-title]').textContent=card.dataset.title;this.querySelector('[data-ns-player-count]').textContent=`${index+1} / ${this.cards.length}`;this.querySelector('[data-ns-player-prev]').disabled=index===0;this.querySelector('[data-ns-player-next]').disabled=index===this.cards.length-1;this.querySelector('[data-ns-player-error]').hidden=true;if(!this.dialog.open){this.dialog.showModal();document.body.classList.add('ns-video-modal-open');}this.syncPreviews();this.player.play()?.catch(()=>{});}
    syncPreviews() {this.cards.forEach(c=>{const v=c.querySelector('video');if(!v)return;v.muted=true;if(document.hidden||this.dialog.open||!this.visibleVideos.has(v)||this.motion.matches){v.pause();return;}if(!v.getAttribute('src')){const s=this.source(c);if(!s)return;v.src=s.url;}v.play()?.catch(()=>{});});}
    navigate(event) {
      if (!['ArrowLeft','ArrowRight','Home','End','PageUp','PageDown'].includes(event.key)) return;
      event.preventDefault();
      const step = this.cards[0]?.getBoundingClientRect().width + 14 || 189;
      let left = this.rail.scrollLeft;
      if (event.key === 'Home') left = 0;
      else if (event.key === 'End') left = this.rail.scrollWidth;
      else left += (['ArrowLeft','PageUp'].includes(event.key) ? -1 : 1) * (event.key.startsWith('Page') ? this.rail.clientWidth : step);
      this.rail.scrollTo({left, behavior:this.motion.matches ? 'auto' : 'smooth'});
    }
    updateScrollbar() {
      const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      const ratio = Math.min(1, this.rail.clientWidth / Math.max(1, this.rail.scrollWidth));
      const progress = max ? Math.max(0, Math.min(1, this.rail.scrollLeft / max)) : 0;
      this.thumb.style.width = `${ratio * 100}%`;
      this.thumb.style.transform = `translateX(${progress * (this.bar.clientWidth - this.bar.clientWidth * ratio)}px)`;
      this.bar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      this.bar.hidden = max < 1;
    }
    scrub(clientX) {
      const rect = this.bar.getBoundingClientRect();
      const travel = rect.width - this.thumb.getBoundingClientRect().width;
      const progress = travel > 0 ? Math.max(0, Math.min(1, (clientX - rect.left - this.barOffset) / travel)) : 0;
      this.rail.scrollLeft = progress * (this.rail.scrollWidth - this.rail.clientWidth);
    }
    disconnectedCallback(){this.cards?.forEach(c=>c.querySelector('video')?.pause());this.player?.pause();if(this.dialog?.open)this.dialog.close();this.abort?.abort();this.resizeObserver?.disconnect();this.videoObserver?.disconnect();this.posterObserver?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
